<template>
  <div id="container">
    <div class="item-box-content">
      <div class="title-font-style">
        <span>发货清单</span>
      </div>

      <el-row :gutter="20">
        <el-col :span="12">
          <div class="join-remove-inline-block">
            <div class="title-content-table">待发货产品</div>

            <el-table
              v-show="!this.$route.params.name"
              border
              ref="tableRef"
              :data="missingdeliveryList"
              tooltip-effect="dark"
              @row-dblclick="RowDbclick"
              @selection-change="handleProductsList"
              :header-cell-style="tableHeader"
              v-loading="loadingMissingProductsTable"
              height="456px"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
            >
              <el-table-column prop="name" type="selection" width="55"></el-table-column>
              <el-table-column show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
              <!-- <el-table-column show-overflow-tooltip prop="seriesName" label="系列"></el-table-column>
              <el-table-column show-overflow-tooltip prop="proName" label="产品名称"></el-table-column>-->
              <el-table-column show-overflow-tooltip prop="proModel" label="型号"></el-table-column>
              <el-table-column show-overflow-tooltip prop="proOrderNum" label="订货号"></el-table-column>
              <!-- <el-table-column show-overflow-tooltip prop="proExtype" label="类型"></el-table-column> -->
              <el-table-column prop="counts" label="数量"></el-table-column>
            </el-table>
            <el-col :span="24" class="join-remove-inline-block-btn">
              <el-button type="primary" @click="moveReportingDeliveryListAll">全部移入</el-button>
              <el-button type="primary" @click="moveReportingDeliveryList" plain>移入发货区</el-button>
            </el-col>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="join-remove-inline-block">
            <div class="title-content-table-right">发货区</div>
            <el-table
              border
              ref="tableRef"
              :data="reportingDeliveryList"
              tooltip-effect="dark"
              @row-dblclick="RowDbclickReturn"
              :header-cell-style="tableHeader"
              @selection-change="handleSelectionChangeReportingDeliveryList"
              v-loading="loadingReportingAreaTable"
              height="456px"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
            >
              <el-table-column prop="name" type="selection" width="55"></el-table-column>
              <el-table-column show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
              <!-- <el-table-column show-overflow-tooltip prop="seriesName" label="系列"></el-table-column>
              <el-table-column show-overflow-tooltip prop="proName" label="产品名称"></el-table-column>-->
              <el-table-column show-overflow-tooltip prop="proModel" label="型号"></el-table-column>
              <el-table-column show-overflow-tooltip prop="proOrderNum" label="订货号"></el-table-column>

              <el-table-column width="155px" prop="counts" label="数量">
                <template slot-scope="scope">
                  <el-input-number
                    v-model="scope.row.counts"
                    @change="handleChange(scope.$index, scope.row)"
                    :min="1"
                    controls-position="right"
                    :max="scope.row.maxcounts"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column v-if="$route.query.sendType === '入库'" width="100px" label="产品序列号">
                <template slot-scope="scope">
                  <span
                    class="approval"
                    @click="updateing(scope.row, scope.$index)"
                    v-show="scope.row.serialCode !== null"
                  >编辑</span>
                  <span
                    class="approval"
                    @click="entering(scope.row, scope.$index)"
                    v-show="scope.row.serialCode === null"
                  >录入</span>
                </template>
              </el-table-column>
            </el-table>
            <el-col :span="24" class="join-remove-inline-block-btn">
              <el-button type="primary" @click="moveMissingdeliveryListAll">全部移出</el-button>
              <el-button type="primary" @click="moveMissingdeliveryList" plain>移出发货区</el-button>
            </el-col>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-------------- 录入产品序列号 ------------>
    <inprouct-serial-code-dialog @inProuctSerial="inProuctSerial" ref="inProuctSerialCodeRefs"></inprouct-serial-code-dialog>
    <!-------------- 二次确认 -------------->
    <open-or-close-dialog
      ref="openOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close-dialog>
  </div>
</template>
<script>
import { addPurchaseLack } from '@/api/purchase/purchasePlanList' // 根据采购合同id查询正常产品清单（分页)
import openOrClose from '@/components/OpenOrClose/index' // 二次确认
import inProuctSerialCodeDialog from '../../dialog/inProuctSerialCodeDialog' // 序列号

export default {
  props: [],
  components: {
    'open-or-close-dialog': openOrClose,
    'inprouct-serial-code-dialog': inProuctSerialCodeDialog
  },
  data () {
    return {
      lackReason: null,
      bigArray: [], // 最全数组
      reportingDeliveryList: [], // 报缺区列表
      loadingReportingAreaTable: false,
      missingdeliveryList: [], // 仓库报缺产品
      loadingMissingProductsTable: false,
      queryParamsSearch: {}, // 待备货产品搜索
      params: {},
      shippedProductList: [],
      title: '', // 弹窗标题
      content: '', // 弹窗内容
      changeMissingProductsList: [], // 仓库报缺产品选中
      changeReportingAreaList: [] // 报缺区选中
    }
  },

  methods: {
    RowDbclick (row) {
      this.changeMissingProductsList = [row]
      this.moveReportingDeliveryList()
    },
    RowDbclickReturn (row) {
      this.changeReportingAreaList = [row]
      this.moveMissingdeliveryList()
    },
    onInitial (val) {
      this.missingdeliveryList = val
      this.missingdeliveryList.forEach((item, index) => {
        this.missingdeliveryList[index].maxcounts = item.counts
      })
      this.bigArray = JSON.parse(JSON.stringify(this.missingdeliveryList))
    },
    // 移入报缺区
    moveReportingDeliveryList () {
      if (this.changeMissingProductsList.length === 0) {
        this.$message.error('请选中产品')
      } else {
        this.changeMissingProductsList.forEach((param) => {
          this.missingdeliveryList.forEach((item, index) => {
            if (item.pccId === param.pccId) {
              let isFalse = false
              if (this.reportingDeliveryList.length > 0) {
                this.reportingDeliveryList.forEach((val, indexs) => {
                  if (val.pccId === item.pccId) {
                    this.reportingDeliveryList[
                      indexs
                    ].counts += this.missingdeliveryList[index].counts
                    isFalse = true
                  }
                })
                if (!isFalse) {
                  this.reportingDeliveryList.push(
                    this.missingdeliveryList[index]
                  )
                }
              } else {
                this.reportingDeliveryList.push(this.missingdeliveryList[index])
              }
            }
          })
        })
        this.changeMissingProductsList.forEach((param) => {
          this.missingdeliveryList.forEach((item, index) => {
            if (item.pccId === param.pccId) {
              this.missingdeliveryList.splice(index, 1)
              index--
            }
          })
        })
      }
    },
    // 全部移出
    moveMissingdeliveryListAll () {
      this.changeReportingAreaList = JSON.parse(
        JSON.stringify(this.reportingDeliveryList)
      )
      this.moveMissingdeliveryList()
    },
    // 全部移入
    moveReportingDeliveryListAll () {
      this.changeMissingProductsList = JSON.parse(
        JSON.stringify(this.missingdeliveryList)
      )
      this.moveReportingDeliveryList()
    },
    // 移出报缺区
    moveMissingdeliveryList () {
      if (this.changeReportingAreaList.length === 0) {
        this.$message.error('请选中产品')
      } else {
        this.changeReportingAreaList.forEach((param) => {
          this.reportingDeliveryList.forEach((item, index) => {
            if (item.pccId === param.pccId) {
              let isFalse = false
              if (this.missingdeliveryList.length > 0) {
                this.missingdeliveryList.forEach((val, indexs) => {
                  if (val.pccId === param.pccId) {
                    this.missingdeliveryList[
                      indexs
                    ].counts += this.reportingDeliveryList[index].counts
                    isFalse = true
                  }
                })
                if (!isFalse) {
                  this.missingdeliveryList.push(
                    this.reportingDeliveryList[index]
                  )
                }
              } else {
                this.missingdeliveryList.push(this.reportingDeliveryList[index])
              }
            }
          })
        })
        this.changeReportingAreaList.forEach((param) => {
          this.reportingDeliveryList.forEach((item, index) => {
            if (item.pccId === param.pccId) {
              this.reportingDeliveryList.splice(index, 1)
              index--
            }
          })
        })
      }
    },
    // 数字改变
    handleChange (index, val) {
      if (
        this.reportingDeliveryList[index].counts ===
        this.reportingDeliveryList[index].maxcounts
      ) {
        this.missingdeliveryList.forEach((item, indexProductsList) => {
          if (item.pccId === this.reportingDeliveryList[index].pccId) {
            this.missingdeliveryList.splice(indexProductsList, 1)
          }
        })
      }
      let isBooean = false
      this.missingdeliveryList.forEach((item, indexBig) => {
        if (item.pccId === this.reportingDeliveryList[index].pccId) {
          this.missingdeliveryList[indexBig].counts =
            this.missingdeliveryList[indexBig].maxcounts -
            (this.reportingDeliveryList[index].counts || 0)
          isBooean = true
        }
      })
      if (!isBooean) {
        const params = JSON.parse(
          JSON.stringify(this.reportingDeliveryList[index])
        )
        params.counts =
          this.reportingDeliveryList[index].maxcounts -
          (this.reportingDeliveryList[index].counts || 0)
        this.missingdeliveryList.push(params)
      }
      this.clearList()
    },
    clearList () {
      this.missingdeliveryList.forEach((item, indexProductsList) => {
        if (!item.counts) {
          this.missingdeliveryList.splice(indexProductsList, 1)
        }
      })
      this.reportingDeliveryList.forEach((item, indexAreaList) => {
        if (!item.counts) {
          this.reportingDeliveryList.splice(indexAreaList, 1)
        }
      })
    },
    // 清单多选
    handleProductsList (val) {
      this.changeMissingProductsList = val
    },
    handleSelectionChangeReportingDeliveryList (val) {
      this.changeReportingAreaList = val
    },

    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 发起报缺
    onInitiateLossReporting () {
      if (this.lackReason === null || this.lackReason === '') {
        this.$message.error('请填写报缺原因')
      } else {
        this.title = '发起报缺'
        this.content = '确定提交报缺？'
        this.$refs.openOrCloseRefs.onInitial()
      }
    },
    // 再次确认
    onUpdataState () {
      const params = {
        pcbId: this.$route.query.pcbId,
        mark: this.lackReason,
        purchaseContractLackVoList: this.reportingDeliveryList
      }
      addPurchaseLack(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('提交成功，请耐心等待上级审核！')
            this.$router.push({
              name: 'contractDetails',
              query: {
                pcbId: this.$route.query.pcbId,
                type: this.$route.query.type
              }
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 编辑
    updateing (val, index) {
      this.$refs.inProuctSerialCodeRefs.onInitial(val, index, 1)
    },
    // 录入
    entering (val, index) {
      this.$refs.inProuctSerialCodeRefs.onInitial(val, index, 0)
    },
    // 序列号传回来的值
    inProuctSerial (val, index) {
      this.reportingDeliveryList[index].serialCode = val
    }
  },
  watch: {
    reportingDeliveryList: {
      handler (newVal) {
        this.$emit('deliveryList', this.reportingDeliveryList)
      },
      deep: true
    }
  }
}
</script>
<style scoped>
.title-content-table {
  padding: 0px 0px 14px 0px;
  text-align: center;
  font-weight: 600;
}
.title-content-table-right {
  padding: 0px 20px 14px 20px;
  text-align: center;
  font-weight: 600;
}
</style>
